import { COMPANY, SERVICES } from './content';

export function Services() {
  return (
    <>
      <section className="page-head">
        <p className="eyebrow">Services</p>
        <h1>What we build</h1>
        <p className="hero-lead">
          Every platform, one team, and the whole job rather than a slice of
          it. If what you need is not listed, it is still worth asking — most
          of our work is custom.
        </p>
      </section>

      <div className="svc-list">
        {SERVICES.map((s) => (
          <section key={s.title} className="svc">
            <div className="svc-head">
              <h2>{s.title}</h2>
              <p>{s.summary}</p>
            </div>
            <ul className="svc-items">
              {s.items.map((i) => (
                <li key={i}>{i}</li>
              ))}
            </ul>
          </section>
        ))}
      </div>

      <section className="cta-band">
        <h2>Not sure which of these you need?</h2>
        <p>
          Describe the problem rather than the solution and we will tell you
          what it actually takes — including if that is less than you expected.
        </p>
        <a className="btn-primary" href={`mailto:${COMPANY.email}`}>
          Get a quote
        </a>
      </section>
    </>
  );
}
